import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Load Auth0 configuration from server endpoint
async function loadAuth0Config() {
  try {
    // Load the auth0-config.js from the server which sets window.AUTH0_CONFIG
    const script = document.createElement('script');
    script.src = '/auth0-config.js';
    
    return new Promise((resolve, reject) => {
      script.onload = () => {
        if (window.AUTH0_CONFIG && window.AUTH0_CONFIG.domain && window.AUTH0_CONFIG.clientId) {
          resolve(window.AUTH0_CONFIG);
        } else {
          reject(new Error('Auth0 configuration is incomplete'));
        }
      };
      script.onerror = () => reject(new Error('Failed to load Auth0 configuration'));
      document.head.appendChild(script);
    });
  } catch (error) {
    console.error('Error loading Auth0 configuration:', error);
    throw error;
  }
}

// Initialize the app with Auth0 configuration
loadAuth0Config()
  .then(config => {
    console.log('Auth0 configuration loaded successfully');
    
    root.render(
      <React.StrictMode>
        <Auth0Provider
          domain={config.domain}
          clientId={config.clientId}
          authorizationParams={{
            redirect_uri: window.location.origin
          }}
        >
          <App />
        </Auth0Provider>
      </React.StrictMode>
    );
  })
  .catch(error => {
    console.error('Auth0 configuration missing or invalid:', error);
    
    // Render error message
    root.render(
      <React.StrictMode>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          backgroundColor: '#f5f5f5'
        }}>
          <h1 style={{ color: '#d32f2f', marginBottom: '16px' }}>Configuration Error</h1>
          <p style={{ color: '#666', textAlign: 'center', maxWidth: '500px' }}>
            Auth0 configuration is missing or incomplete. Please check your environment variables:
            <br />
            <code>AUTH0_DOMAIN</code> and <code>AUTH0_CLIENT_ID</code>
          </p>
          <p style={{ color: '#999', fontSize: '14px', marginTop: '16px' }}>
            Error: {error.message}
          </p>
        </div>
      </React.StrictMode>
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 